import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { Address } from '../../models/address.model'
import { AddressHistory } from '../../models/records.model'
import { BaseRepository, ListResponse } from '../base.repository'

@Injectable({
  providedIn: 'root',
})
export class RecordsRepository extends BaseRepository<Address> {
  public constructor() {
    super({
      resourceName: 'records',
      defaultSorting: [{ property: 'createdAt', direction: 'asc' }],
    })
  }

  public getRecordsHistory(
    referenceId: string
  ): Observable<ListResponse<AddressHistory>> {
    return this.http.get<ListResponse<AddressHistory>>(
      `${this.url}/${referenceId}/history`
    )
  }
}
